import React from 'react';
import { Text } from '@leverege/ui-elements';
import I18N from '@leverege/i18n';
import { jsx as _jsx } from "react/jsx-runtime";
const {
  t
} = I18N.ns('molten.dataViewers.list.ResultsCountAction');
export default {
  id: 'list.ResultsCountAction',
  matches: {
    client: 'ListDataViewer',
    use: 'filterBar'
  },
  layout: {
    sort: 'bbb'
  },
  handles: () => true,
  customComponent: ResultsCountView
};
function ResultsCountView(props) {
  const {
    context: {
      clientProps
    }
  } = props;
  return clientProps?.data?.count != null ? /*#__PURE__*/_jsx(Text, {
    variant: "listResultsCount|caption",
    children: t('result', {
      count: clientProps.data.count
    })
  }) : null;
}